export enum PurchasePaymentType {
  Fiat = 'fiat',
  Crypto = 'crypto',
}
